<h1 class="h3 mb-2 text-gray-800">Doctores</h1>
<!-- <p class="mb-4">DataTables is a third party plugin that is used to generate the demo table below. For more information
    about DataTables, please visit the <a target="_blank" href="https://datatables.net">official DataTables
        documentation</a>.</p> -->

<!-- DataTales Example -->
<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Fotos</h6>
    </div>
    <div class="card-body">
        <form name="form" (ngSubmit)="f.form.valid && guardarDatos()" #f="ngForm">
            <div class="form-group">
                <label>Nombre</label>
                <input type="text" class="form-control" name="key" [(ngModel)]="contenido.key" />
            </div>
            <div class="form-group">
                <label>Foto</label>
                <div><img style="height: 200px" [src]="getImageUrl(contenido)" /></div>
                <div *ngIf="urlFotos"><img [src]="urlFotos" height="200"></div>
                <input type="file" accept=".jpg, .jpeg, .png" #fileupload="ngModel" [(ngModel)]="myFile" name="myFile"
                    (change)="fileEvent($event)" class="form-control"
                    [ngClass]="{'is-invalid':  f.submitted && fileupload.invalid}" required />
                <div *ngIf="f.submitted && fileupload.invalid" class="invalid-feedback">
                    <div *ngIf="fileupload.errors.required">El motivo es requerido</div>
                </div>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">Guardar Datos</button>
                <a routerLink="/fotos" class="btn btn-link">Volver</a>
            </div>
        </form>
    </div>
</div>